$('#review-submit-btn').on('click', function () {

    if (!$('.user-param-input-star').rateit('value')) {
        showToast('danger', 'Error', 'You need to rate first.', 5000);
        return;
    }

    if (!user) {
        $('#loginModal').modal('show');
        return;
    }
    let textarea = $('#user-review');
    console.log(textarea);
    if (!textarea.val()) {
        showToast('danger', 'Error', 'Comment box not be empty.');
        return;
    }

    let params = new FormData();
    params.append('text', textarea.val());
    params.append('review_id', textarea.attr('data-review-id'));
    params.append('school_id', schoolId);
    params.append('user_id', user.id);
    params.append('type', 'COMMENT');


    axios.post(`${APP_BASE_URL}/reviews/server/route/ajax_review_school.php`, params).then(res => {
        if (res && res.data && parseInt(res.data)) {
            showToast('success', 'Success', 'Thanks for posting review. Your review has been submitted to the school for comments', 5000);
            $('#writeReview').hide();
            textarea.val('');
        } else {
            showToast('danger', 'Error', (res.hasOwnProperty('message') && res.message !== 'success') ? res.message : 'No Review data updated.', 5000);
        }
    }).catch(err => {
        if (DEBUG) console.log('error', err);
    });
});


$('.user-param-input-star').bind('rated', function () {

    let _self = this;

    /*    var url = new URL(window.location.href);*/

    if (!user) {
        $('#loginModal').modal('show');
        return;
    }

    let params = new FormData();
    params.append('school_id', schoolId);
    params.append('user_id', user.id);
    params.append($(this).attr('data-rating-param').trim().replace(/ /gi, '_'), parseFloat($(this).rateit('value').toFixed(2)));

    axios.post(`${APP_BASE_URL}/reviews/server/route/ajax_rate_school.php`, params).then(res => {
        if (res.data) {
            showToast('success', 'Success', `Rated ${$(_self).siblings().text().replace(/:/gi, '').trim().toUpperCase()} Successfully.`, 5000);
        } else {
            $(_self).rateit('value', 0);
            showToast('danger', 'Error', (res.message) ? res.message : 'Something went wrong.', 5000);
        }
    }).catch(err => {
        if (DEBUG) console.log('error', err);
    });
});


function showToast(priority, title, message, timeout = 5000) {
    // $.toaster({priority: priority.toLowerCase(), title: title, message: message, settings: {timeout: timeout}});
    if (priority === 'success') {
        toastr.success(message, 'Success', {
            "positionClass": "toast-bottom-center",
            "showDuration": timeout,
            "hideDuration": timeout
        });
    } else {
        toastr.error(message, 'Error', {
            "positionClass": "toast-bottom-center",
            "showDuration": timeout,
            "hideDuration": timeout
        });
    }


}
